<template>
    <div>
        <el-table
                class="poster-table"
                :data="posterList"
                :row-key="() => Math.random()">
            <el-table-column
                    prop="orderNum"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="title"
                    label="标题">
            </el-table-column>
            <el-table-column
                    label="图片">
                <template slot-scope="scope">
                    <image-wrapper
                            :src="scope.row.posterUrl"
                            width="200px"
                    ></image-wrapper>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作">
                <template slot-scope="scope">
                    <el-button
                            type="primary"
                            circle
                            icon="el-icon-edit"
                            @click="handleUpdate(scope.row)"
                    ></el-button>
                    <el-button
                            type="danger"
                            circle
                            icon="el-icon-delete"
                            @click="handleRemove(scope.row.id)"
                    ></el-button>
                </template>
            </el-table-column>
        </el-table>
        <poster-detail :value="posterId" @refresh="refreshList" ref="detail"></poster-detail>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex';
    import ImageWrapper from 'components/image';
    import posterDetail from '../detail';

    export default {
        name: 'posterList',
        data() {
            return {
                posterId: null,
                sortable: '.poster-table'
            };
        },
        components: {
            ImageWrapper,
            posterDetail
        },
        computed: {
            ...mapGetters('posterSetting', ['posterList'])
        },
        methods: {
            ...mapMutations('posterSetting', ['toggleDetailDialogVisible']),
            ...mapActions('posterSetting', ['list', 'remove']),
            handleUpdate(data) {
                this.$refs.detail.setDetail({...data, orderNum: data.orderNum == null ? 1 : data.orderNum});
                this.toggleDetailDialogVisible(true);
            },
            handleRemove(id) {
                this.$confirm('确认删除此海报吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.remove(id).then(() => {
                            this.$message.success('删除成功！');
                            this.$emit('refresh');
                        });
                    })
                    .catch(() => {
                    });
            },
            refreshList() {
                this.$emit('refresh');
            }
        }
    };
</script>

<style lang="less" scoped>
</style>
